import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import moment from "moment";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import { Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import CloudIcon from "assets/svgs/cloud_icon";
import { useToast } from "modules/navbar/top/store/toasterStore";
import {
  formatDate,
  _getMaxDate,
  _getMinDate,
  getCurrentUserRole,
  ADMIN_ACCESS,
  isDownloadDisabled,
} from "modules/utilities/utility";
import { isEmpty } from "lodash";

function InputData({
  setStartDateFilter,
  setEndDateFilter,
  downloadStatsData,
  handleDownload
}) {
  const [startDate, setStartDate] = useState(
    new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  );
  const [endDate, setEndDate] = useState(new Date());
  const { setToaster } = useToast();
  const [ticketData, setTicketData] = useState([]);

  useEffect(() => {
    if (downloadStatsData?.length) {
      setTicketData([
        ...downloadStatsData?.map((item) => {
          return {
            ...item,
            createdAt: moment(item?.createdAt).format("DD MMM YYYY, h:mm a"),
            updatedAt: moment(item?.updatedAt).format("DD MMM YYYY, h:mm a"),
          };
        }),
      ]);
    }
  }, [downloadStatsData]);

  function formatCommentsToBulletPoints(ticket) {
    if (!ticket || !ticket.comments) {
      return "";
    }

    const formattedComments = ticket?.comments
      .map((comment) => {
        const firstName = comment?.action_taker?.first_name;
        const createdAt = moment(comment?.created_at).format(
          "DD MMM YYYY, h:mm a"
        );
        const description = comment?.description;
        return `• ${firstName} -> ${createdAt} -> ${description}`;
      })
      .join("\n");
    return formattedComments;
  }


  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    setStartDate("");
  };
  const handleResetEndDate = () => {
    setEndDate("");
  };

  const handleFilterSubmit = (e) => {
    const sd = moment(startDate);
    const ed = moment(endDate);
    const sdFormatted = sd.format('YYYY-MM-DD');
    const edFormatted = ed.format('YYYY-MM-DD');
  
    if (ed.diff(sd, 'days') > 31) {
      setToaster(
        "Date Filter",
        "Please select a date range within 31 days",
        "danger"
      );
    }

    e.preventDefault();
    setStartDateFilter(sdFormatted);
    setEndDateFilter(edFormatted);
  };
  

  return (
    <div className="d-flex justify-content-end mt-2">
      <Form onSubmit={handleFilterSubmit} className="data-filter">
        <div className="d-flex gap-2">
          <Form.Group>
            <div className="input-container mt-1" style={{ zIndex: "999" }}>
              {startDate ? (
                ""
              ) : (
                <div className="calendar-icon-container">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                placeholderText="Start Date"
                dateFormat="dd-MM-yyyy"
                value={startDate ? formatDate(startDate) : ""}
                className="input-with-icon"
                style={{ zIndex: "999" }}
                minDate={_getMinDate(endDate)}
                maxDate={endDate}
              />
              {startDate && (
                <span className="reset-icon" onClick={handleResetStartDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Group>
          <Form.Group>
            <div className="input-container mt-1" style={{ zIndex: "999" }}>
              {endDate ? (
                ""
              ) : (
                <div className="calendar-icon-container">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="calendar-icon"
                  />
                </div>
              )}
              <DatePicker
                selected={endDate}
                onChange={handleEndDateChange}
                placeholderText="End Date"
                dateFormat="dd-MM-yyyy"
                value={endDate ? formatDate(endDate) : ""}
                style={{ zIndex: "999999" }}
                maxDate={_getMaxDate(startDate)}
                minDate={
                  new Date(endDate.getTime() - 1 * 24 * 60 * 60 * 1000)
                }
                />
              {endDate && (
                <span className="reset-icon" onClick={handleResetEndDate}>
                  <BsX />
                </span>
              )}
            </div>
          </Form.Group>

          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fs-1">Filter by Date</div>
              </Tooltip>
            }
          >
            <Button
              variant="primary"
              className="mt-1 float-end w-25 h-25"
              type="submit"
            >
              Filter
            </Button>
          </OverlayTrigger>
          <div className="d-flex justify-content-center">
            <OverlayTrigger
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="overlay-trigger-example"
                >
                  <div className="fs-1">Download Data</div>
                </Tooltip>
              }
            >
              <Button
                type="primary"
                onClick={handleDownload}
                size="medium"
                className="mt-1"
                disabled={
                  isDownloadDisabled || (isEmpty(downloadStatsData) || 
                    !ADMIN_ACCESS.includes(getCurrentUserRole()))
                    ? true
                    : false
                }
              >
                <div>
                  <CloudIcon />{" "}
                </div>
              </Button>
            </OverlayTrigger>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default InputData;